import { useEffect, useState } from 'react'
import MaterialIcon from './MaterialIcon'
import { dismissToast, subscribeToasts, type ToastEntry } from '../../lib/toast'

const typeStyles: Record<ToastEntry['type'], { border: string; icon: string }> = {
  info: { border: 'border-white/10', icon: 'info' },
  success: { border: 'border-kilo-accent/30', icon: 'check_circle' },
  error: { border: 'border-red-500/30', icon: 'error_outline' },
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastEntry[]>([])

  useEffect(() => subscribeToasts(setToasts), [])

  if (toasts.length === 0) return null

  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-[100] flex flex-col gap-2 px-4"
      style={{ bottom: 'calc(5.5rem + env(safe-area-inset-bottom, 0px))' }}
      aria-live="polite"
    >
      {toasts.map((toast) => {
        const styles = typeStyles[toast.type]
        return (
          <div
            key={toast.id}
            className={`pointer-events-auto flex items-start gap-3 rounded-2xl border bg-[#1A1A1A] p-4 text-white shadow-lg ${styles.border}`}
          >
            <MaterialIcon name={styles.icon} size="sm" className="mt-0.5 shrink-0 text-white/70" />
            <div className="min-w-0 flex-1">
              <p className="text-sm leading-snug text-white">{toast.message}</p>
              {toast.action ? (
                <button
                  type="button"
                  className="mt-2 text-sm font-semibold text-kilo-accent"
                  onClick={() => {
                    toast.action?.onClick()
                    dismissToast(toast.id)
                  }}
                >
                  {toast.action.label}
                </button>
              ) : null}
            </div>
            {toast.dismissable !== false ? (
              <button
                type="button"
                aria-label="Dismiss"
                className="shrink-0 rounded-lg p-1 text-white/50 hover:text-white"
                onClick={() => dismissToast(toast.id)}
              >
                <MaterialIcon name="close" size="sm" />
              </button>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
